import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CssClassName } from './enums';

@Injectable({
    providedIn: 'root',
})
export class LayoutService {
    isMobile$ = signal(false);
    readonly mainContainerClasses$ = new BehaviorSubject<CssClassName[]>([]);

    addMainContainerClasses(...classes: CssClassName[]) {
        this.mainContainerClasses$.next([
            ...this.mainContainerClasses$.value,
            ...classes,
        ]);
    }

    removeMainContainerClasses(...classes: CssClassName[]) {
        this.mainContainerClasses$.next([
            ...this.mainContainerClasses$.value.filter(
                (className) => !classes.includes(className)
            ),
        ]);
    }
}
